module.exports = __webpack_public_path__ + "img/msu.c4a24331.png";